import { getNativeInfo, normalizeAppName } from '@docs/common'
import request from './request'
import { shoppingService } from './apiPrefix'

export enum COUPON_CODE_TYPE {
  'COLLECTION' = 1,
  'VARIANT' = 2,
}

export type CouponItemType = {
  code: string
  create_time: string
  expire_at: number
  value_type: 'percentage' | 'fixed_amount'
  value: string
  summary: string
  code_type: COUPON_CODE_TYPE // 1品类 2单品
  sku_or_collection_id: number
  skus: string[]
}
export const EUFY_SECURITY_APPLICATION_NAME = 'eufy_security'
export const EUFY_LIFT_APPLICATION_NAME = 'eufy_life'
export const EUFY_HOME_APPLICATION_NAME = 'eufy_home'
export const EUFY_MEGA_APPLICATION_NAME = 'eufy_mega'
function getCookie(name: string): string | undefined {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift();
  }
  return undefined;
}
/**
 * 查看优惠券列表
 * status 1|2  //1:查看未过期  2:查看已过期
 */
export const getCoupons = async (status: number) => {
  const { token,gtoken,appName,country } = await getNativeInfo()
  const data = await request<{
    data: {
      coupons: Array<CouponItemType>
    }
  }>(`${await shoppingService()}/query/coupon/list`, {
    data: { query_status: status },
    method: 'POST',
    headers: {
      'Model-Type': 'PHONE' ,
      'X-Auth-Token': token,
      'Gtoken': gtoken || getCookie('gtoken'),
      'App-Name': appName && normalizeAppName(appName),
      'App-Country': country ? country : 'us',
      accessToken: getCookie('access_token'),
      openudid: getCookie('openudid'),
    },
  })
  return data?.data?.coupons
}
